















































































































































































import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import {
  ReservationModel,
  ReservationAccUnitModel,
  SearchRestrictionsModel,
} from "./types";
import ReservationFormHolder from "./ReservationFormHolder.vue";
import ReservationFormStayPeriod from "./ReservationFormStayPeriod.vue";
import ReservationFormUnits from "./ReservationFormUnits.vue";
import ReservationFormUnitGuests from "./ReservationFormUnitGuests.vue";
import ReservationFormPrice from "./ReservationFormPrice.vue";
import RequireRole from "@/components/misc/RequireRole.vue";
import FormDescription from "@/components/misc/FormDescription.vue";
import { SelectedAvailability } from "@/shared/models/availability";
import { Getter } from "vuex-class";
import { policyChecker } from "@/shared/roles";
import { JwtClaims } from "@/store/modules/auth";
import { DistributionChannelEnum } from "@/shared/models/enums.type";

@Component({
  components: {
    ReservationFormHolder,
    ReservationFormStayPeriod,
    ReservationFormUnits,
    ReservationFormUnitGuests,
    ReservationFormPrice,
    FormDescription,
    RequireRole
  },
})
export default class ReservationForm extends Vue {
  @PropSync("reservation", { default: new ReservationModel() })
  model?: ReservationModel;

  @Prop({ default: false }) isLoadingOrSaving?: boolean;
  @Prop({ default: false }) isModalOpen?: boolean;

  @Prop({ default: undefined }) availabilities?: SelectedAvailability[];
  @Prop({ default: undefined }) period?: Date[];
  @Prop({ default: undefined }) restrictions?: SearchRestrictionsModel;
  @Prop({ default: undefined }) tenantTags?: string[];

  @Prop() isMobile?: boolean;

  @Getter("appParams/typeId") tenantTypeId?: number;

  @Getter("auth/claims") claims?: JwtClaims;

  selectedUnit: ReservationAccUnitModel | null = null;

  isOverbooked(isOverbooked: number[]) {
    this.$emit("overbooked", isOverbooked);
  }

  isNotAvailable(isNotAvailable: number[]) {
    this.$emit("notAvailable", isNotAvailable);
  }
  isLoadingChanged(isLoadingChanged: boolean){
    this.$emit("isLoadingChanged", isLoadingChanged);
  }

  get periodSet() {
    return this.model?.arrivalDate && this.model?.departureDate;
  }

  get reservationIsReadonly() {
    if ((policyChecker("OWNER_LEVEL_3")(this.claims) &&
      this.model?.distributionChannelTypeId === DistributionChannelEnum.OwnersReservation) ||
      !policyChecker("OWNER_LEVEL_3")(this.claims)){
      return false;
    }
    return true;
  }

  remarksOpen = true;
  toggleRemarks() {
    this.remarksOpen = !this.remarksOpen;
  }

  stayPeriodFromUnits: Date[] | null = null;
  stayPeriodChanged() {
    if (this.model?.accomodationUnitTypes) {
      this.stayPeriodFromUnits = [];

      const period = {
        minArrivalDate: "",
        maxDepartureDate: "",
      };

      for (const unit of this.model?.accomodationUnitTypes) {
        if (
          !period.minArrivalDate ||
          unit.arrivalDate.substring(0, 10) < period.minArrivalDate
        ) {
          period.minArrivalDate = unit.arrivalDate.substring(0, 10);
        }
        if (
          !period.maxDepartureDate ||
          unit.departureDate.substring(0, 10) > period.maxDepartureDate
        ) {
          period.maxDepartureDate = unit.departureDate.substring(0, 10);
        }
      }

      this.stayPeriodFromUnits.push(
        new Date(period.minArrivalDate),
        new Date(period.maxDepartureDate)
      );
    }
  }

  get tags(){
    return this.model?.tags;
  }
  set tags(values){
    const uniqueTags = [] as string[];
    // Match new tags with existing values. Push only unique values.
    values?.forEach(x => {
      this.tenantTags?.forEach(tt => {
        if(tt.toLowerCase() === x.toLowerCase() && !uniqueTags.map(uV => uV.toLowerCase()).includes(tt.toLowerCase())){
          uniqueTags.push(tt);
        }
      })
      if(!uniqueTags.map(uV => uV.toLowerCase()).includes(x.toLowerCase())){
        uniqueTags.push(x);
      }
    })

    this.$emit('tagsChanged', uniqueTags);
  }

  get rules() {
    return {
      maxLength: (value: string) =>
        !value ||
        value.length <= 2000 ||
        this.$t("Validation.MaxLength", { count: 2000 }),
      maxCharacters: (value: string[]) =>
        !value ||
        value.every(x => x.length <= 50) ||
        this.$t("Validation.MaxLength", { count: 50 }),
    };
  }
}
